<template>
    <section>
        <b-modal v-model="open" :title="$t('message.edit_unit')" ref="modal" id="modal-unit-edit">
            <vue-form-generator ref="unitEdit" :schema="schema" :model="model" :options="formOptions" @validated="onValidated"></vue-form-generator>
            <template #footer>
                <b-btn @click="open=false">{{$t('message.cancel')}}</b-btn>
                <b-btn @click="validate" type="primary">{{$t('message.save')}}</b-btn>
            </template>
        </b-modal>
    </section>
</template>

<script>
    import VueFormGenerator from 'vue-form-generator'
    import mixins from '../../../modules/mixins'
    import eventBus from '../../../modules/eventBus'
    import axios from 'axios' // todo remove axios

    export default {
        name: 'edit-unit',
        mixins: [mixins],
        data () {
            return {
                open: false,
                isValid: false,
                item: false,
                model: {
                    id: null,
                    building: null,
                    name: null,
                    floor: '',
                    tenants: 1,
                    pricePerUnit: ''
                },
                schema: {
                    fields: [{
                        type: 'input',
                        inputType: 'hidden',
                        model: 'id'
                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.$t('message.name'),
                        i18n: {
                            label: 'message.name'
                        },
                        model: 'name',
                        placeholder: this.$t('message.unit_name_placeholder'),
                        featured: true,
                        required: true,
                        validator: VueFormGenerator.validators.string
                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.$t('message.floor'),
                        i18n: {
                            label: 'message.floor'
                        },
                        model: 'floor',
                        required: false
                    }, {
                        type: 'input',
                        inputType: 'integer',
                        i18n: {
                            label: 'message.tenants'
                        },
                        model: 'tenants',
                        required: false
                    }, {
                        type: 'checkboxText',
                        i18n: {
                            label: 'message.price_estimate_cold_water',
                            checkboxLabel: 'message.from_parent_object',
                            unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.liter')
                        },
                        model: 'pricePerLiterCold',
                        pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                        validator: [VueFormGenerator.validators.regexp]
                    }, {
                        type: 'checkboxText',
                        i18n: {
                            label: 'message.price_estimate_hot_water',
                            checkboxLabel: 'message.from_parent_object',
                            unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.liter')
                        },
                        model: 'pricePerLiterHot',
                        pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                        validator: [VueFormGenerator.validators.regexp]
                    }, {
                        type: 'checkboxText',
                        i18n: {
                            label: 'message.price_estimate_power',
                            checkboxLabel: 'message.from_parent_object',
                            unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.power')
                        },
                        model: 'pricePerPower',
                        pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                        validator: [VueFormGenerator.validators.regexp]
                    }, {
                        type: 'checkboxText',
                        i18n: {
                            label: 'message.price_estimate_heat',
                            checkboxLabel: 'message.from_parent_object',
                            unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.heat_units')
                        },
                        model: 'pricePerUnit',
                        pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                        validator: [VueFormGenerator.validators.regexp]
                    }]
                },
                formOptions: {
                    validateAfterLoad: false,
                    validateAfterChanged: true
                }
            }
        },
        methods: {
            onValidated  (isValid) {
                this.isValid = isValid
            },
            validate () {
                this.$refs.unitEdit.validate()
                if (this.isValid) {
                    axios.post(`/api/v1/edit-entity/${this.item.id}?type=${this.item.type}`, this.model)
                        .then(response => {
                            this.open = false
                            eventBus.emit('change', {force: true, source: 'edit-unit'})
                        }) // TODO catch ERROR
                    this.open = false
                }
            },
            show (item) {
                this.item = item
                axios.get(`/api/v1/entity/${item.id}?type=${item.type}`).then(response => {
                    this.model = response.data.data
                })
                this.open = true
            }
        }
    }
</script>

<style scoped>

</style>
